import Controller from './controller';

class App extends Controller {}

export const app = new App();
